import { Component, OnInit, Input,
         Output, EventEmitter }    from '@angular/core';
import { FormGroup, FormControl, FormArray,
         FormBuilder, Validators } from '@angular/forms';

import { CsvService }              from './../../csv.service';
import { User }                    from './../../../../models/program/user';
import { Router }                  from '@angular/router';
import { ErrorService }            from '../../../../shared/services/error.service';
import { BatchResponse }           from '../../../../models/program/batch-response';
import { BatchCommitInfo }         from '../../../../models/program/batch-commit-info';

@Component({
  selector: 'app-batch',
  templateUrl: './batch.component.html',
  styleUrls: ['./batch.component.less']
})

export class BatchComponent implements OnInit {
  @Input() batchResponse: BatchResponse;
  @Input() programId: number;
  @Input() sessionId?: number;
  @Output() reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() loadSettingsFromBatch: EventEmitter<{
    inputType: string,
    programId: number,
    sessionId?: number
    batchCommitInfo: BatchCommitInfo
  }> = new EventEmitter<{
    inputType: string,
    programId: number,
    sessionId?: number,
    batchCommitInfo: BatchCommitInfo
  }>();
  public teamAmount: number;
  public detectedTeamAmount: number;
  public existingUsers: User[];
  public batchAttrs: string[] = [];
  public batchForm: FormGroup;
  public events: any[] = [];
  public committed: boolean;
  public inputType: string;
  public usersToMove: number[] = [];
  public newDetectedTeamAmount: number;
  public errors: string[];
  public saving: boolean;
  public teamsToCreateErr: boolean;
  public sendWelcome: boolean = false;
  public welcomeSettings: FormGroup;

  constructor(
    private router: Router,
    private errorService: ErrorService,
    private csvService: CsvService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.welcomeSettings = this._fb.group({
      subject: this._fb.control(null, Validators.required),
      body: this._fb.control(null, Validators.required)
    });
    if (this.batchResponse.groups) {
      this.detectedTeamAmount = this.batchResponse.groups.length;
      this.newDetectedTeamAmount = this.batchResponse.groups.reduce((acc, curr) => acc + (!curr.exists ? 1 : 0)  , 0)
    } else {
      this.detectedTeamAmount = 0;
      this.newDetectedTeamAmount = 0;
    }
    this.teamAmount = this.detectedTeamAmount;
    if (this.batchResponse.attributes) {
      this.batchResponse.attributes.forEach(batchAttr => {
        this.batchAttrs.push(batchAttr.name);
      });
    }

    this.updateInputType();

    this.batchForm = this._fb.group({
      batch_ref: [this.batchResponse.batch_ref, <any>Validators.required],
      group_count: [this.teamAmount, <any>Validators.required],
      users_to_move: this._fb.array([])
    });

    if (this.batchResponse.existing_users) {
      this.existingUsers = this.batchResponse.existing_users;
      this.setUsers(this.existingUsers);
    } else {
      this.existingUsers = null;
    }
  }

  /**
   * Public methods
   */

  public setSendWelcome(sendWelcome: boolean): void {
    this.sendWelcome = sendWelcome;
  }

  public moveUser(id: number, bool: boolean): void {
    if (bool) {
      this.addUser(id);
    } else {
      this.removeUser(id);
    }
  }

  public continueToSettings() {
    this.loadSettingsFromBatch.emit({ inputType: this.inputType, programId: this.programId, sessionId: this.sessionId, batchCommitInfo: this.batchForm.value as BatchCommitInfo });
  }

  public resetData(bool: boolean): void {
    this.reset.emit(bool);
  }

  public commitBatchSkipSettings(): void {
    this.saving = true;
    this.csvService.commitBatchTeams(
      this.programId,
      {'commit_info': this.batchForm.value as BatchCommitInfo},
      this.sendWelcome ? this.welcomeSettings.value : false,
      this.sessionId
    )
    .subscribe(res => {
      this.saving = false;
      this.committed = true;
      this.reset.emit(true);
      if (!this.sessionId) {
        this.router.navigate(['dashboard', 'programs', this.programId, 'teams' ]);
      }
    }, error => {
      this.saving = false;
      this.errors = this.errorService.messages(error);
    });
  }

  /**
   * Private Methos
   */

  private setUsers(arr: User[]): void {
    arr.forEach(user => this.addUser(user.id));
  }

  private addUser(id?: number): void {
    this.usersToMove.push(id);
    const control = <FormArray>this.batchForm.controls['users_to_move'];
    control.push(new FormControl(id));
  }

  private removeUser(id: number): void {
    const control = <FormArray>this.batchForm.controls['users_to_move'];
    control.removeAt(this.usersToMove.indexOf(id));
    this.usersToMove.splice(this.usersToMove.indexOf(id), 1);
  }

  public checkForTeamsToCreateErr(): boolean {
    return this.teamsToCreateErr;
  }

  public updateInputType() {
    if (this.teamAmount > 1) {
      this.inputType = 'wave';
      this.teamsToCreateErr = false;
    } else if (this.teamAmount === 1) {
      this.inputType = 'lone_group';
      this.teamsToCreateErr = false;
    } else {
      this.teamsToCreateErr = true;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/batch/batch.component.ts